module.exports = __webpack_public_path__ + "img/keyboard-brightness-low.5b2bd8fa.svg";